const XP_LEVELS = [
    '0',
    '300',
    '900',
    '2 700',
    '6 500',
    '14 000',
    '23 000',
    '34 000',
    '48 000',
    '64 000',
    '85 000',
    '100 000',
    '120 000',
    '140 000',
    '165 000',
    '195 000',
    '225 000',
    '265 000',
    '305 000',
    '355 000'
];
export default XP_LEVELS;
